import React from "react";
import {Criterion} from "./Criterion";
import './PrettifyCombination.css';

interface CombinationExpressionProps {
    criteria: Criterion[];
}

export const CombinationExpression = (props: CombinationExpressionProps) => {
    let atLeastThreeCriterion = props.criteria.length >= 3;
    let criteria = props.criteria.map((criterion, index) => createCriterion(criterion, index));

    return (
        <span>
            <span>Must be</span>
            {criteria.map((criterion, index) => {
                return <React.Fragment key={`criterion--${index}`}>
                    <span>{criterion.beginsWithVowel ? ' an ' : ' a '}</span>
                    {criterion.criterion}
                    {index + 1 !== criteria.length
                        ? <span>{atLeastThreeCriterion ? ', or ' : ' or '}</span>
                        : ''
                    }
                </React.Fragment>
            })}
        </span>
    )
}

const createCriterion = (criterion: Criterion, index: number): CriterionWrapper => {
    let filters: string[] = [];
    filters.push(...criterion.genres);
    if (criterion.mood !== undefined) {
        filters.push(criterion.mood);
    }
    if (criterion.nationality !== undefined) {
        filters.push(criterion.nationality);
    }

    let firstLetterVowel = filters.length > 0 && beginsWithVowel(filters[0]);

    let elements: React.ReactElement[] = [];
    for (let i = 0; i < filters.length; i++) {
        let filter = filters[i];
        let key = `criterion--filter--${index}--${filter.toLowerCase()}`;
        if (filters.length === 1) {
            elements.push(<span key={key} className={"combinationFilter"}>{filter.toLowerCase()}</span>);
        } else if (i + 1 === filters.length) {
            elements.push(<React.Fragment key={key}>
                <span> and </span>
                <span className={"combinationFilter"}>{filter.toLowerCase()}</span>
            </React.Fragment>);
            // Only add comma between genres if at least 3 genres
        } else if (filters.length >= 3) {
            elements.push(<React.Fragment key={key}>
                <span className={"combinationFilter"}>{filter.toLowerCase()}</span>
                <span>, </span>
            </React.Fragment>);
        } else {
            elements.push(<span key={key} className={"combinationFilter"}>{filter.toLowerCase()}</span>);
        }
    }

    if (criterion.decade !== undefined) {
        elements.push(<React.Fragment key={`criterion--decade--${index}}`}>
            <span> song from the </span>
            <span className={"combinationDecade"}>{criterion.decade}s</span>
        </React.Fragment>);
    } else {
        elements.push(<span key={`criterion--end--${index}}`}> song</span>);
    }


    return {
        criterion: <>{elements}</>,
        beginsWithVowel: firstLetterVowel
    }
}

interface CriterionWrapper {
    criterion: React.ReactElement;
    beginsWithVowel: boolean;
}

const vowels = ("aeiouAEIOU");
const beginsWithVowel = (val: string): boolean => {
    return vowels.indexOf(val[0]) !== -1;
}